<template>
  <div class="landing container-m">
    <div class="header">
      <div class="header-logo"><img :src="Logo" /></div>
      <div class="centered">
        <h2>{{t("Welcome to Layoga")}}</h2>
        <p>{{t("Your way to get into a healthy lifestyle")}}</p>
      </div>
    </div>
    <div class="body">
      <p>{{t("In just a few steps we will build a customized fitness and nutrition plan for you. Sounds good?")}}</p>
      <router-link to="/quiz" class="btn">{{t("Let's start!")}}</router-link>
    </div>
    <div class="footer">
      <p>{{t("Already has an account?")}} <router-link to="/plan/login">{{t("Sign In")}}</router-link></p>
    </div>
  <PoweredBy />
  </div>
</template>

<script>
import t from '@/lib/Locale'
import Logo from '@/assets/icons/lotus-white.png';
import Fito from "@/lib/fito";
import PoweredBy from "@/components/ui/widgets/PoweredBy.vue";

export default {
name: "Landing",
  components: {PoweredBy},
  async mounted() {
    if (localStorage.getItem('login-token')) {
      const login = await Fito().Login.CheckLogin();
      if (login && login.subscriber) window.location.href = '/plan/yoga';
      return false;
    }
  },
  data() {
    return {
      Logo,
      freeTrialDays: 7
    }
  },
  methods : {
    t,
    start() {
      this.$router.push('/quiz')
    }
  }
}
</script>
